// Gedeelde teksten: navigatiebalk, voettekst, taalkiezer.
// Vertaling van fr/common.js — exact dezelfde sleutels.
// De sleutels packs.* horen ALLEEN in dit fragment thuis (tp/tpList lezen ze,
// met terugval op de waarde uit de database).
export default {
  'nav.home': 'Home',
  'nav.shop': 'Shop',
  'nav.rules': 'Spelregels',
  'nav.about': 'Over ons',
  'nav.contact': 'Contact',
  'nav.cart': 'Mijn winkelmandje',
  'nav.admin': 'Beheer',
  'nav.adminShort': 'Admin',
  'nav.adminTitle': 'Admintoegang',
  'nav.order': 'Bestellen',
  'nav.cartEmpty': 'Uw winkelmandje is leeg',
  'nav.checkout': 'Afrekenen',
  'nav.login': 'Inloggen',
  'nav.loginShort': 'Login',
  'nav.logout': 'Uitloggen',
  'nav.orders': 'Bestellingen',
  'nav.myOrders': 'Mijn bestellingen',
  'nav.profile': 'Profiel',
  'nav.myProfile': 'Mijn profiel',
  'nav.language': 'Taal',

  'footer.tagline':
    'Samen magische familiemomenten creëren! Onze puzzels maken van de gender reveal van jullie baby een onvergetelijk avontuur.',
  'footer.badge.interactive': '🎲 Interactief',
  'footer.badge.festive': '🎊 Feestelijk',
  'footer.badge.family': '💝 Familie',
  'footer.nav': 'Navigatie',
  'footer.legal': 'Juridisch',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Algemene voorwaarden',
  'footer.paymentSecurity': 'Veilig betalen',
  'footer.legalNotice': 'Wettelijke vermeldingen',
  'footer.connected': 'Blijf op de hoogte',
  'footer.newsletter': 'Ontvang het laatste nieuws:',
  'footer.newsletterPlaceholder': 'jouw@email.com',
  'footer.madeWith': 'Gemaakt met',
  'footer.madeFor': 'voor magische gezinnen.',

  // Productteksten (komen normaal uit de database, hier vertaald via tp/tpList).
  'packs.flash.name': 'Pack Essentiel',
  'packs.flash.description': 'Alleen de speldoos — de rest bereidt u zelf voor.',
  'packs.flash.longDescription':
    'U ontvangt de Joyful Reveal-doos, en niets anders: elf puzzelstukjes die vraag na vraag te winnen zijn, en het twaalfde om te krassen — dat is het stukje dat alles verklapt. De spelregels staan samengevat op de achterkant van de doos en zijn ook online beschikbaar. De vragen schrijft u zelf, en u zorgt zelf voor iets om de twee teams uit elkaar te houden. Wilt u liever dat alles al klaarligt, kijk dan naar het Pack Premium.',
  'packs.flash.features':
    'De speldoos met de 12 stukjes|11 stukjes te winnen + 1 kraslootje|Spelregels samengevat op de achterkant van de doos|Online versie van de regels via de QR-code',

  'packs.premium.name': 'Pack Premium',
  'packs.premium.description': 'Het volledige spel: alles ligt klaar, u hoeft niets meer voor te bereiden.',
  'packs.premium.longDescription':
    'Alles wat in de doos zit, plus de drie extra’s die de avond maken: twee katoenen zakjes om de teams uit elkaar te houden, de vragenlijst gedrukt op karton van 400 g met de elf vragen al uitgeschreven en een blanco model om er zelf te bedenken, en een herinneringsenvelop die u na het feest achter een fotolijst schuift.',
  'packs.premium.features':
    'De speldoos met de 12 stukjes|2 katoenen zakjes voor de twee teams|De vragenlijst gedrukt op karton van 400 g|Een blanco model voor uw eigen vragen|De herinneringsenvelop om na het feest te bewaren',
  "footer.maFacture": "Mijn factuur terugvinden",
};
